export const debounce = (func) => {
  let timer;
  return function (...args) {
    const context = this;
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      func.apply(context, args);
    }, 300);
  };
};

export const uuid = () => {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
    return (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16);
  });
};

export const getUserDevice = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  const isTablet =
    /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
      userAgent,
    );
  return isTablet ? "tablet" : "laptop";
};

export const convertToINR = (number) => {
  if (number === undefined || number === null) return "N/A";
  return number.toLocaleString("en-IN", {
    maximumFractionDigits: 2,
    style: "currency",
    currency: "INR",
  });
};

export const convertDate = (inputFormat, reverse = false) => {
  if (!inputFormat) return "N/A";
  function pad(s) {
    return s < 10 ? "0" + s : s;
  }
  var d = new Date(inputFormat);
  return reverse
    ? [pad(d.getFullYear()), pad(d.getMonth() + 1), pad(d.getDate())].join("-")
    : [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join("-");
};

export const convertEpochTime = (time) => {
  let options = {
    year: "2-digit",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: false,
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  };
  return new Intl.DateTimeFormat("en-IN", options).format(new Date(time)); // returns DD/MM/YYYY hh:mm ss
};

export const convertToTitleCase = (s) => {
  return s
    .replace(/^[-_]*(.)/, (_, c) => c.toUpperCase())
    .replace(/[-_]+(.)/g, (_, c) => " " + c.toUpperCase());
};

export const convertArrayToCSV = (dataArray) => {
  const result = dataArray
    .map((row) =>
      row
        .map((item) =>
          typeof item === "string" && item.indexOf(",") >= 0
            ? `"${item}"`
            : String(item),
        )
        .join(","),
    )
    .join("\n");
  return result;
};

export const isValidDate = (date) => /^\d{4}-\d{2}-\d{2}$/.test(date);

export const downloadFileFromArray = (array, fileName = "file") => {
  const csv = convertArrayToCSV(array);

  const data = encodeURI("data:text/csv;charset=utf-8," + csv);

  // Create a virtual Anchor tag
  const link = document.createElement("a");
  link.setAttribute("href", data);
  link.setAttribute("download", `${fileName}.csv`);

  // Append the Anchor tag in the actual web page or application
  document.body.appendChild(link);

  // Trigger the click event of the Anchor link
  link.click();

  // Remove the Anchor link form the web page or application
  document.body.removeChild(link);
};

export const format_mmmdyyyy = (date) => {
  let dt = date;
  if (typeof date === "string") {
    dt = new Date(date);
  }
  return dt.toLocaleString("en-CA", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

// Formats a date as `DD.MM.YY, h.mmAM/PM`
export const formatDotDateTimeShort = (input) => {
  if (!input) return "";
  const d = new Date(input);
  if (isNaN(d.getTime())) return "";
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Kolkata",
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  }).formatToParts(d);
  const get = (type) => parts.find((p) => p.type === type)?.value ?? "";
  const ampm = get("dayPeriod").toUpperCase();
  return `${get("day")}.${get("month")}.${get("year")}, ${get("hour")}.${get("minute")}${ampm}`;
};
